module.exports = __webpack_public_path__ + "static/img/qywx.f6debd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qywx.png
// module id = IVSC
// module chunks = 0